import { get, uniqBy } from 'lodash';
import React from 'react';
import { useTranslate } from '../../../core/translate';
import Compare from '../../common/compare/Compare';
import OptionsFilter from './filters/OptionsFilter';
import FullPageCompareHeader from './fullPageCompareHeading/FullPageCompareHeader';
import useCompareScrolling from './useCompareScrolling';
import { combineWithEngine, getAppPath } from './utils';

const analyticsKey = 'compare capabilities';

const toColumn = ({ bodyTypeId, driveType, engine }, engineRowData) => {
  const id = `${bodyTypeId}_${driveType}_${engine}`;
  return get(engineRowData, id);
};

const buildTrimPath = (styleId) => {
  const currentPath = location.pathname;
  const pathName = getAppPath(currentPath);

  return `${pathName}/trims?styleId=${styleId}&hideReveal=true`;
};

const toColumns = (combinedOptions, engineRowData) => {
  return combinedOptions.map((option) => {
    return {
      data: option,
      selectionLink: buildTrimPath(option.styleId),
      groups: toColumn(option, engineRowData),
    };
  });
};

const CapabilitiesCompareInner = (props) => {
  const {
    features,
    filteredOptions,
    config,
    displayFilterCount,
    displayInTableFilter,
    driveTypeSectionEl,
  } = props;
  const { engineRowData, groups } = features;
  let uniqueOptions = uniqBy(
    filteredOptions,
    (x) => `${x.bodyTypeId}_${x.driveType}_${x.engine}`
  );

  const columns = toColumns(uniqueOptions, engineRowData);
  const translate = useTranslate();
  const [scrolling] = useCompareScrolling();

  const headers = uniqueOptions.map(({ engineDescription, trimName }) => {
    return { primaryText: engineDescription, trimKey: trimName };
  });

  const filterText = translate('capability.compare.filtered.v3', {
    number: columns && columns.length,
  });

  return (
    <Compare
      headers={headers}
      columns={columns}
      compareGroups={groups}
      config={config}
      isScrolled={scrolling}
      displaySort={false}
      displayFilterCount={displayFilterCount}
      driveTypeSectionEl={driveTypeSectionEl}
      displayInTableFilter={displayInTableFilter}
      itemDescription={translate('component.common.select.engine')}
      filterText={columns && columns.length && filterText}
      hideMSRPDisclosure={true}
      isFeatures={true}
      analyticsKey={analyticsKey}></Compare>
  );
};

const CapabilitiesCompare = (props) => {
  const {
    config,
    selections,
    modelMatrix,
    options,
    headerTitle,
    onClose,
  } = props;

  const combinedOptions = combineWithEngine(config, options)(modelMatrix);
  return (
    <>
      <FullPageCompareHeader
        title={headerTitle}
        analyticsKey={analyticsKey}
        onClose={onClose}
      />
      <OptionsFilter
        selections={selections}
        options={combinedOptions}
        config={config}
        analyticsKey={analyticsKey}>
        {(
          filteredOptions,
          displayFilterCount,
          displayInTableFilter,
          driveTypeSectionEl
        ) => (
          <CapabilitiesCompareInner
            {...props}
            filteredOptions={filteredOptions}
            displayFilterCount={displayFilterCount}
            driveTypeSectionEl={driveTypeSectionEl}
            displayInTableFilter={displayInTableFilter}
          />
        )}
      </OptionsFilter>
    </>
  );
};

export default CapabilitiesCompare;
